import { render, staticRenderFns } from "./BowButtonCircle.vue?vue&type=template&id=4ec55411&"
import script from "./BowButtonCircle.vue?vue&type=script&lang=js&"
export * from "./BowButtonCircle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BowIcons: require('/workspace/components/atoms/BowIcons/BowIcons.vue').default})
